import axios from "axios";
import qs from "qs";

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

export default {
  login(user) {
    return apiClient.post("/login", user);
  },
  logout(user) {
    return apiClient.post("/logout", user);
  },
  get(payload) {
    if (payload.data) {
      return apiClient.get(payload.url, {params:payload.data});
    }else {
      return apiClient.get(payload.url);
    }
  },
  post(payload) {
    return apiClient.post(payload.url, qs.stringify(payload.data));
  },
  put(payload) {
    return apiClient.put(payload.url, qs.stringify(payload.data));
  },
  delete(payload) {
    return apiClient.delete(payload.url);
  },
  getFile(data) {
    return apiClient.get("edicto/" + data + "/file", {
      responseType: "arraybuffer"
    });
  },
  // getFile(data) {
  //   return apiClient.get("/documentos/" + data.data + "/file/" + data.perito_id + "/" + data.periodo_id
  //    ,{
  //     responseType: "arraybuffer"
  //   }
  // );
  // },
  getPdf(payload) {
    return apiClient.get(payload.url, {
      params: payload.data,
      responseType: "arraybuffer"
    });
  }
};
